"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DropdownForm_1 = __importDefault(require("@App/kit/fields/DropdownForm"));
const InputTextForm_1 = __importDefault(require("@App/kit/fields/InputTextForm"));
const react_1 = __importDefault(require("react"));
const CheckboxForm_1 = __importDefault(require("@App/kit/fields/CheckboxForm"));
const form_field_types_1 = require("@App/enum/form-field-types");
const MultiDropdownForm_1 = __importDefault(require("@Fields/MultiDropdownForm"));
const RadioButtonForm_1 = __importDefault(require("@Fields/RadioButtonForm"));
const FormFieldFromProps = (props) => {
    const getFormFieldComponent = () => {
        switch (props.type) {
            case form_field_types_1.FormFieldTypes.DROPDOWN:
                return react_1.default.createElement(DropdownForm_1.default, Object.assign({}, props));
            case form_field_types_1.FormFieldTypes.CHECKBOX:
                return react_1.default.createElement(CheckboxForm_1.default, Object.assign({}, props),
                    props.children && props.children,
                    " ");
            case form_field_types_1.FormFieldTypes.TEXT:
                return react_1.default.createElement(InputTextForm_1.default, Object.assign({}, props));
            case form_field_types_1.FormFieldTypes.RADIO:
                return react_1.default.createElement(RadioButtonForm_1.default, Object.assign({}, props));
            case form_field_types_1.FormFieldTypes.MULTI_DROPDOWN:
                return react_1.default.createElement(MultiDropdownForm_1.default, Object.assign({}, props));
        }
    };
    const { inputHeader } = props;
    if (inputHeader) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            inputHeader,
            getFormFieldComponent()));
    }
    else {
        return getFormFieldComponent();
    }
};
exports.default = FormFieldFromProps;
